export default __webpack_public_path__ + "static/media/Rawan.c700112f.jpg";